import React from 'react'

/* Styles */
import './Weighing.css'

/* Images */
import tabela from '../img/tabelaPesos.png'

/**
 * Modules
 */
import { Modal, Select, Input, List, Avatar, Button, Breadcrumb } from 'antd'
import { Link } from 'react-router-dom';

import TopBar from '../topBar/TopBar';

const WeighingView = (props) => {
    return (
        <div id='champContent'>

            <TopBar />

            <div style={{ height: '70px' }}></div>

            <div className="champsBlock">
                <Breadcrumb>
                    <Breadcrumb.Item><Link to={'/home'}>Início</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs', state: { userType: props.userType } }}>
                            Campeonatos
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs/' + props.champKey }}>
                            {props.champObject.nome}
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Pesagem</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className='HomeContent'>
                <Select
                    showSearch
                    placeholder="Filtrar faixa"
                    optionFilterProp="children"
                    onChange={props.chooseAFaixaFilter}
                    className='WeighingSelectInput'
                    style={{ marginRight: '2%' }}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    <Select.Option value={null}> </Select.Option>
                    <Select.Option value="whiteSmoke">Branca</Select.Option>
                    <Select.Option value="grey">Cinza</Select.Option>
                    <Select.Option value="yellow">Amarela</Select.Option>
                    <Select.Option value="orange">Laranja</Select.Option>
                    <Select.Option value="green">Verde</Select.Option>
                    <Select.Option value="#ffcc99">Colorido</Select.Option>
                    <Select.Option value="blue">Azul</Select.Option>
                    <Select.Option value="purple">Roxa</Select.Option>
                    <Select.Option value="brown">Marrom</Select.Option>
                    <Select.Option value="black">Preta</Select.Option>
                </Select>

                <Select
                    showSearch
                    placeholder="Filtrar peso"
                    optionFilterProp="children"
                    onChange={props.chooseAPesoFilter}
                    className='WeighingSelectInput'
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    <Select.Option value={null}> </Select.Option>
                    <Select.Option value="Galo">Galo</Select.Option>
                    <Select.Option value="Pluma">Pluma</Select.Option>
                    <Select.Option value="Pena">Pena</Select.Option>
                    <Select.Option value="Leve">Leve</Select.Option>
                    <Select.Option value="Médio">Médio</Select.Option>
                    <Select.Option value="Meio Pesado">Meio Pesado</Select.Option>
                    <Select.Option value="Pesado">Pesado</Select.Option>
                    <Select.Option value="Super Pesado">Super Pesado</Select.Option>
                    <Select.Option value="Pesadíssimo">Pesadíssimo</Select.Option>
                </Select>

                <Select
                    showSearch
                    placeholder="Filtrar idade"
                    optionFilterProp="children"
                    onChange={props.chooseAIdadeFilter}
                    className='WeighingSelectInput'
                    style={{ marginRight: '2%' }}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    <Select.Option value={undefined}> </Select.Option>
                    <Select.Option value="Pré-Mirim">Pré-Mirim</Select.Option>
                    <Select.Option value="Mirim 1">Mirim 1</Select.Option>
                    <Select.Option value="Mirim 2">Mirim 2</Select.Option>
                    <Select.Option value="Infantil 1">Infantil 1</Select.Option>
                    <Select.Option value="Infantil 2">Infantil 2</Select.Option>
                    <Select.Option value="Infanto 1">Infanto 1</Select.Option>
                    <Select.Option value="Infanto 2">Infanto 2</Select.Option>
                    {/*
                    <Select.Option value="Mirim">Mirim</Select.Option>
                    <Select.Option value="Infantil">Infantil</Select.Option>
                    <Select.Option value="Infanto">Infanto</Select.Option>
                    */}
                    <Select.Option value="Juvenil">Juvenil</Select.Option>
                    <Select.Option value="Adulto">Adulto</Select.Option>
                    {/*
                    <Select.Option value="Master">Master</Select.Option>
                    */}
                    <Select.Option value="Master 1">Master 1</Select.Option>
                    <Select.Option value="Master 2">Master 2</Select.Option>
                </Select>

                <Select
                    showSearch
                    placeholder="Filtrar equipe"
                    optionFilterProp="children"
                    onChange={props.chooseAEquipeFilter}
                    className='WeighingSelectInput'
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    <Select.Option value={null}> </Select.Option>
                    {
                        props.arrayOfTeams.map(team => {
                            return (
                                <Select.Option key={team.nome} value={team.nome}>{team.nome}</Select.Option>
                            )
                        })
                    }
                </Select>

                <Input placeholder="Buscar aluno" id='searchInput' className='WeighingInput browser-default' onChange={e => props.searchStudent(e.target.value)} />

                <Button className='WeighingButton' onClick={props.openWeightChartDialog}>Ver tabela de pesos</Button>

                <div style={{ clear: 'both' }}></div>

                <List
                    className="demo-loadmore-list"
                    itemLayout="horizontal"
                    dataSource={props.filteredArrayOfStudents}
                    loading={props.loading}
                    renderItem={competitor => (
                        <List.Item>
                            <List.Item.Meta
                                style={{ fontSize: 'x-small' }}
                                avatar={<Avatar size='small' style={{ backgroundColor: competitor.faixa }} />}
                                title={competitor.nome}
                                description={competitor.peso + ' | ' + competitor.idade + ' | ' + competitor.equipe}
                            />
                            <div>
                                <Input
                                    type='text'
                                    defaultValue={competitor.pesoOficial}
                                    placeholder='Peso oficial'
                                    className='WeighingListInput browser-default'
                                    onBlur={input => props.setAndCheckWeight(input.target.value, competitor.peso, competitor.idade, competitor.sexo, competitor.__key)}
                                />

                                {competitor.apto ?
                                    <div className='WeighingTag' style={{ color: 'green' }}>
                                        Apto
                                    </div> :
                                    <div className='WeighingTag' style={{ color: 'red' }}>
                                        Não apto
                                    </div>
                                }
                            </div>
                        </List.Item>
                    )}
                />
            </div>

            <Modal
                title="Tabela de pesos"
                visible={props.weightChartDialog}
                onCancel={props.closeWeightChartDialog}
                footer={[
                    <Button key='close' onClick={props.closeWeightChartDialog}>Fechar</Button>
                ]}
            >
                <img src={tabela} alt="Tabela de Peso" width="100%" style={{ marginTop: '20px' }} />
            </Modal>
        </div>
    )
}

export default WeighingView